import { toDate as o } from "./toDate.js";
function g(a, n) {
  const t = o(a), e = o(n);
  return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
}
export {
  g as default,
  g as isSameMonth
};
//# sourceMappingURL=isSameMonth.js.map
